import { Component, OnInit, ViewChild } from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { Router } from '@angular/router';
import { BinesSeachResponse } from '../../_models/bin-seach-result';
import { ZeroService } from '../../_services/zero/zero.service';
import { REST_SERVICES } from '../../_services/settings';
import { DatatableComponent} from '../../semantic/datatable/datatable.component'

@Component({
  selector: 'app-search-supervisor',
  templateUrl: './search-supervisor.component.html',
  styles: [':host {display: block;}'],
  host: ROUTE_ANIMATION_HOST, 
  animations: [ROUTE_ANIMATION],
})

export class SearchSupervisorComponent implements OnInit {
 
  constructor(
    private router : Router, 
    private zeroService: ZeroService) { }
  
  ngOnInit() {    
  
  }
}
